var neon = {
  neon1: 'hsl(68, 60.0%, 99.0%)',
  neon2: 'hsl(67, 90.0%, 96.1%)',
  neon3: 'hsl(67, 86.3%, 94.4%)',
  neon4: 'hsl(67, 82.5%, 90.5%)',
  neon5: 'hsl(67, 79.8%, 82.3%)',
  neon6: 'hsl(68, 78.5%, 69.8%)',
  neon7: 'hsl(68, 78.5%, 60.6%)',
  neon8: 'hsl(68, 53.0%, 48.0%)',
  neon9: 'hsl(68, 53.0%, 36.0%)',
  neon10: 'hsl(68, 53.0%, 24.0%)',
  neon11: 'hsl(68, 53.0%, 18.0%)',
  neon12: 'hsl(68, 53.0%, 10.0%)'
};
var neonA = {
  neonA1: 'hsl(60, 94.9%, 38.7%, 0.016)',
  neonA2: 'hsl(67, 98.6%, 47.7%, 0.075)',
  neonA3: 'hsl(67, 99.8%, 46.4%, 0.106)',
  neonA4: 'hsl(68, 99.4%, 45.6%, 0.173)',
  neonA5: 'hsl(68, 99.8%, 44.5%, 0.318)',
  neonA6: 'hsl(68, 99.7%, 43.9%, 0.538)',
  neonA7: 'hsl(68, 100%, 43.9%, 0.702)',
  neonA8: 'hsl(68, 99.7%, 33.3%, 0.762)',
  neonA9: 'hsl(68, 99.7%, 22.9%, 0.832)',
  neonA10: 'hsl(68, 99.4%, 14.5%, 0.887)',
  neonA11: 'hsl(68, 99.7%, 10.3%, 0.914)',
  neonA12: 'hsl(69, 99.9%, 5.6%, 0.953)'
};
var neonDark = {
  neon1: 'hsl(68, 53.0%, 4.0%)',
  neon2: 'hsl(68, 53.3%, 5.9%)',
  neon3: 'hsl(72, 47.3%, 10.0%)',
  neon4: 'hsl(73, 52.0%, 13.2%)',
  neon5: 'hsl(73, 58.3%, 16.3%)',
  neon6: 'hsl(72, 65.6%, 20.0%)',
  neon7: 'hsl(70, 76.7%, 24.7%)',
  neon8: 'hsl(68, 100%, 29.0%)',
  neon9: 'hsl(68, 79.0%, 60.0%)',
  neon10: 'hsl(68, 79.0%, 68.0%)',
  neon11: 'hsl(68, 79.0%, 78.0%)',
  neon12: 'hsl(68, 79.0%, 88.0%)'
};
var neonDarkA = {
  neonA1: 'hsl(0, 0%, 0%, 0)',
  neonA2: 'hsl(61, 94.0%, 62.9%, 0.030)',
  neonA3: 'hsl(73, 97.1%, 67.4%, 0.093)',
  neonA4: 'hsl(72, 99.0%, 65.5%, 0.147)',
  neonA5: 'hsl(74, 99.1%, 62.0%, 0.210)',
  neonA6: 'hsl(72, 99.6%, 59.8%, 0.285)',
  neonA7: 'hsl(70, 99.7%, 55.8%, 0.398)',
  neonA8: 'hsl(68, 100%, 49.9%, 0.553)',
  neonA9: 'hsl(68, 99.7%, 65.3%, 0.913)',
  neonA10: 'hsl(68, 100%, 72.9%, 0.929)',
  neonA11: 'hsl(68, 99.9%, 81.9%, 0.950)',
  neonA12: 'hsl(69, 99.9%, 90.2%, 0.975)'
};

export { neon, neonA, neonDark, neonDarkA };
